export enum AnalyticsColors {
	PRIMARY = 'var(--color-analytics-primary)',
	PRIMARY900 = 'var(--color-analytics-primary-900)',
	PRIMARY800 = 'var(--color-analytics-primary-800)',
	PRIMARY700 = 'var(--color-analytics-primary-700)',
	PRIMARY600 = 'var(--color-analytics-primary-600)',
	PRIMARY500 = 'var(--color-analytics-primary-500)',
	PRIMARY400 = 'var(--color-analytics-primary-400)',
	PRIMARY300 = 'var(--color-analytics-primary-300)',
	PRIMARY200 = 'var(--color-analytics-primary-200)',
	PRIMARY100 = 'var(--color-analytics-primary-100)',
}
